import { useEffect, useState } from 'react';

import { Column } from 'primereact/column';
import { DataTable } from 'primereact/datatable';

import { useContactList } from '../../hooks/ServiceHooks';

import './ContactsList.css';


export default function ContactListPage() {
    const {data, loading} = useContactList();

    useEffect(() => {
        console.log(data);
    }, [data]);
    
    return (
        <div className='data-page'>
            <DataTable value={data?.contacts} paginator rows={25} dataKey="scan_id" tableStyle={{ minWidth: '50rem' }} filterDisplay="menu" loading={loading}>
                <Column field="section_id" header="Section Id" sortable filter></Column>
                <Column field="plugin" header="Plugin" sortable filter></Column>
                <Column field="status" header="Status" sortable filter></Column>
                <Column field="ts" header="Updated" sortable></Column>
                <Column field="output" header="Results" filter></Column>
            </DataTable>
        </div>
    );
}